import type { JSX } from '@builder.io/qwik';
import { component$, Slot, useContext } from '@builder.io/qwik';
import { AnalyticsContext } from '~/contexts/AnalyticsContext';
import type { AnalyticsEventActionType } from '~/types/AnalyticsType';
import type { PAGE_BUILDER_BLOCK_TYPE } from '~/types/AppData/PageBuilder/PageBuilderBlockTypesType';

type AnalyticsClickType = {
  component_name?: string;
  component_type?: PAGE_BUILDER_BLOCK_TYPE;
  component_placement?: number;
  amount_of_articles?: number;
  link_position: number;
  click_link_url: string;
  wrapperClass?: string;
};

export default component$<AnalyticsClickType>(
  ({
    component_name,
    component_type,
    component_placement,
    amount_of_articles,
    link_position,
    click_link_url,
    wrapperClass,
  }): JSX.Element => {
    const analytics = useContext(AnalyticsContext);
    const currentId = component_name
      ? `${analytics.event.component_id}/${component_name}`
      : (analytics.event.component_id ?? '');
    const event = {
      GA_event_action: 'page component click' as AnalyticsEventActionType,
      component_id: currentId,
      component_name: component_name ?? analytics.event.component_name,
      component_type: component_type ?? analytics.event.component_type,
      component_placement:
        component_placement ?? analytics.event.component_placement,
      section_placement: analytics.event.section_placement,
      column_index_mobile: analytics.event.column_index_mobile,
      column_index_desktop: analytics.event.column_index_desktop,
      column_number_of_links: analytics.event.column_number_of_links,
      amount_of_articles:
        amount_of_articles ?? analytics.event.amount_of_articles,
      link_position,
      click_link_url,
    };

    return (
      <div
        onClick$={() => {
          analytics.actions.sendEvent(event);
        }}
        class={wrapperClass}
      >
        <Slot />
      </div>
    );
  }
);
